import { motion, useAnimate } from "motion/react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom"


export function QuadrantStrategy() {


  const quadrants = [
    {
      number: "1",
      title: "Readiness from Meter 2 Market:",
      subtitle: "For Carbon Neutral to Net Zero Journey",
      description: "To establish a robust, auditable, and regulation-aligned energy baseline and translate it into a Board-approved, implementable 5-year RE Transition Plan.",
      bgColor: "bg-teal-500",
      link: "/report",
      position: "top-left"
    },
    {
      number: "2",
      title: "Verified data into Auditable Claims",
      subtitle: "Through Tokenization",
      description: "Convert verified RE data into assured, traceable, & non-duplicated RE claims by tokenizing, applying algorithm-based matching between RE generation & consumption.",
      bgColor: "bg-cyan-400",
      // link: "#certificate",
      position: "top-right"
    },
    {
      number: "3",
      title: "Globally Verifiable",
      subtitle: "Reporting & Disclosure",
      description: "Translate RE and emissions data into standardized, regulator-aligned, and globally verifiable disclosures",
      bgColor: "bg-cyan-300",
      // link: "#compliance",
      position: "bottom-right"
    },
    {
      number: "4",
      title: "Program",
      subtitle: "Monitoring & Risk Mitigations",
      description: "Board approved RE plan to be executed through transparent marketplace minimizing regulatory, execution, financial, and reputational risks.",
      bgColor: "bg-sky-400",
      // link: "#onboarding",
      position: "bottom-left"
    }
  ];

  console.log({quadrants});
  

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-6xl mx-auto"
        >
          {/* Header */}
          <div className="mb-12 text-center">
            <div className="inline-block bg-teal-500 px-2 py-1 mb-4"></div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl mb-4 bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
              4 Quadrant Strategy of RE 100
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Innovative Globally traceable Green Energy Sourcing & compliance platform
            </p>
          </div>

          {/* Quadrants Grid */}
                 <div className="grid grid-cols-1 md:grid-cols-2 gap-1 max-w-4xl mx-auto">
            {quadrants.map((quadrant, index) => (
              <motion.a
                key={index}
                href={quadrant.link}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className={`${quadrant.bgColor} p-8 relative group cursor-pointer hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] ${
                  quadrant.position === "top-left" ? "rounded-tl-2xl" :
                  quadrant.position === "top-right" ? "rounded-tr-2xl" :
                  quadrant.position === "bottom-left" ? "rounded-bl-2xl" :
                  "rounded-br-2xl"
                }`}
              >
                {/* Number Badge */}
                <div className="absolute -top-3 -left-3 w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-xl font-bold text-gray-900">{quadrant.number}</span>
                </div>

                {/* Content */}
                <div className="relative z-10">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-2">
                    {quadrant.title}
                  </h3>
                  <p className="text-lg md:text-xl font-semibold text-gray-900 mb-4">
                    {quadrant.subtitle}
                  </p>
                  <p className="text-sm md:text-base text-white/90 leading-relaxed">
                    {quadrant.description}
                  </p>
                </div>

                {/* Hover Arrow */}
                <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowRight className="w-6 h-6 text-white" />
                </div>

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity rounded-inherit"></div>
              </motion.a>
            ))}
          </div>

          {/* Footer Note */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-8 text-center"
          >
            <p className="text-sm text-gray-500 italic">
              Click on any quadrant to explore detailed strategies and implementation roadmaps
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
